import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "additional_info",
    object: "additional_info",
    header: [

      { text: "Descripción", value: "description" },
      { text: "Orden", value: "order" },
      { text: "Acciones", value: "actions", sortable: false, width:"20%" }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
